import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseHomeFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.23325L20.2884 11.0318C21.286 11.6093 22.5639 11.2263 23.0794 10.1954L23.1346 10.085C23.602 9.15021 23.2708 8.01322 22.3747 7.47554L12.7717 1.71376C12.2967 1.42875 11.7033 1.42875 11.2283 1.71376L1.62529 7.47554C0.729153 8.01323 0.398061 9.15021 0.865432 10.085L0.920649 10.1954C1.43612 11.2263 2.71405 11.6093 3.71158 11.0318L12 6.23325ZM4.46312 12.3299C4.15408 12.5089 3.82967 12.6351 3.5 12.7117V20C3.5 20.8284 4.17157 21.5 5 21.5H8C8.82843 21.5 9.5 20.8284 9.5 20V15.5H14.5V20C14.5 20.8284 15.1716 21.5 16 21.5H19C19.8284 21.5 20.5 20.8284 20.5 20V12.7117C20.1703 12.6351 19.8459 12.5089 19.5369 12.3299L12 7.96649L4.46312 12.3299Z"
        fill={color}
      />
    </svg>
  );
};
